/**
 * 用户登录 localstorage 管控
 * localstorage 本地储存有限，限做管控
 */

// all in UserLocalStorageKey
import api from '@/api';
import { post } from '@/utils/http';
import { Cookies } from '@/utils/utils';
import { getUiFitment } from '@/utils/accessResources';
import { getEffectiveAppId, getLogo } from '@/utils/intConfiguration';

const ULStorageKey = {
  token: 'token',
  name: 'name',
  userInfo: 'user_info',
  appId: 'appId',
  accountId: 'accountId',
  tenantId: 'tenantId',
  tenantCode: 'tenantCode',
  phone: 'phone',
  pwdStatus: 'pwdStatus',
  method: 'method',
};

// 设置 用户系统
const setUserSys = (env) => {
  localStorage.setItem(ULStorageKey.appId, env);
};
// token 注入
const setToken = (loginInfo) => {
  const {
    token = '', userId = '',
  } = loginInfo || {};
  const effectiveAppId = getEffectiveAppId(loginInfo && loginInfo.appId);
  if (effectiveAppId) {
    localStorage.setItem(ULStorageKey.appId, effectiveAppId);
  }
  localStorage.setItem(ULStorageKey.token, token);
  localStorage.setItem(ULStorageKey.token, token);
  // localStorage.setItem(ULStorageKey.appId, appId);
  localStorage.setItem(ULStorageKey.userInfo, JSON.stringify(loginInfo));
  post(api.garyEnv)
    .then((m) => {
      Cookies.set('lg_env', m.env);
    });
};
const setAccount = (loginAccountInfo, loginInfo) => {
  const {
    accountId = '', tenantId = '', tenantCode = '', name = '', phone = '', appId = '', pwdStatus = '',
  } = loginAccountInfo || {};
  // eslint-disable-next-line no-underscore-dangle
  const _useInfo = { ...loginInfo, ...loginAccountInfo };
  localStorage.setItem(ULStorageKey.tenantId, tenantId);
  localStorage.setItem(ULStorageKey.tenantCode, tenantCode);
  localStorage.setItem(ULStorageKey.userInfo, JSON.stringify(_useInfo));
  localStorage.setItem(ULStorageKey.accountId, accountId);
  try {
    localStorage.setItem(ULStorageKey.method, JSON.stringify({
      user_id: accountId,
    }));
    localStorage.setItem('user_id', accountId);
  } catch (error) {

  }
  localStorage.setItem(ULStorageKey.phone, phone);
  localStorage.setItem(ULStorageKey.name, name);
  localStorage.setItem(ULStorageKey.pwdStatus, pwdStatus);
  // info 优先；无 info 时依次为账号接口、登录接口、当前缓存和域名配置，空响应不再覆盖有效 appId
  const effectiveAppId = getEffectiveAppId(appId || (loginInfo && loginInfo.appId));
  if (effectiveAppId) {
    localStorage.setItem(ULStorageKey.appId, effectiveAppId);
  }
  // if(!uitype) {
  //   (async () => {
  //     try {
  //       await getUiFitment();
  //       console.log('UI Fitment data successfully fetched and stored.');
  //     } catch (error) {
  //       console.error('Failed to fetch UI Fitment data', error);
  //     }
  //   })();
  //   }
};

// 移除 所有与用户登录相关的 localstorage
const rmToken = () => {
  Object.values(ULStorageKey).forEach((key) => {
    if (key !== 'appId') localStorage.setItem(key, '');
  });
  localStorage.removeItem('elements');
  localStorage.removeItem('routeCache');
  localStorage.removeItem('workflow_add');
  localStorage.removeItem('workflow_edit');

  Cookies.remove('lg_env');
};
// TODO 后端在权限4期 会统一接口此处逻辑会删除
// 雏鹰二期 已统一
// eslint-disable-next-line arrow-body-style
const obtainUrl = (str) => {
  const appId = getLogo().appId || localStorage.getItem('appId');
  // eslint-disable-next-line no-unused-vars
  let url = '';

  // eslint-disable-next-line no-unused-expressions
  str === 'url_sms' ? url = api.userLoginSmsV2 : url = api.internetSendVerifyCode;
  // if(appId === '10016' && str === 'url_sms') {
  //   url = api.userLoginSmsV2
  // }
  return url;
  // switch (appId) {
  //   case '10009':
  //     // eslint-disable-next-line no-unused-expressions
  //     str === 'url_sms' ? url = api.merchantCrmSms : url = api.merchantSendVerifyCode;
  //     break;
  //   case '10016':
  //     // eslint-disable-next-line no-unused-expressions
  //     str === 'url_sms' ? url = api.crmSms : url = api.sendVerifyCode;
  //     break;
  //   case '20001':
  //     // eslint-disable-next-line no-unused-expressions
  //     str === 'url_sms' ? url = api.gylSms : url = api.gylSendVerifyCode;
  //     break;
  //   case '20004':
  //     // eslint-disable-next-line no-unused-expressions
  //     str === 'url_sms' ? url = api.gylSms : url = api.gylSendVerifyCode;
  //     break;
  //   case '10020':
  //     // eslint-disable-next-line no-unused-expressions
  //     str === 'url_sms' ? url = api.gylSms : url = api.gylSendVerifyCode;
  //     break;
  //   default:
  //     break;
  // }
  // return url;
};
export {
  setToken,
  rmToken,
  setUserSys,
  setAccount,
  obtainUrl,
};
